/**
 * Created by intellicar-rinas on 9/10/17.
 */
import React, {Component} from 'react';
import './InGreySpotter.css';
import {lightTheme, darkTheme} from '../../../../Layouts/config/mapConfig/mapStyleConfig'
import moment from 'moment';
import InSlider from './InSlider/InSlider';

class InGreySpotter extends Component{

    state = {
        dayFilter: [
            {name: 'Mon', active: true},
            {name: 'Tue', active: true},
            {name: 'Wed', active: true},
            {name: 'Thu', active: true},
            {name: 'Fri', active: true},
            {name: 'Sat', active: true},
            {name: 'Sun', active: true},
        ],
        alarmTypes: [
            {name: 'LDWL', key:1, active: true},
            {name: 'LDWR', key:2, active: true},
            {name: 'HW', key:3, active: true},
            {name: 'TSR', key:4, active: true},
            {name: 'UFCW', key:5, active: true},
            {name: 'FCW', key:6, active: true},
            {name: 'PCW', key:7, active: true},
        ],
        spotSize: 0.1,
        normalizeSpotByVehicle: false,
        scaleSpotSize: true,
    };  

    greySpotSize = [
        {name: '100m', value: 0.1},
        {name: '200m', value: 0.2},
        {name: '500m', value: 0.5},
        {name: '1km',  value: 1},
        {name: '2km',  value: 2},
        {name: '5km',  value: 5},
        {name: '10km', value: 10},
    ]

    kmUnit = 111; // 111.699

    minAlertCount = 2;

    toggleDay =day=> {
        day.active =! day.active;
        this.setState({dayFilter: this.state.dayFilter}, ()=> {
            this.processData();
        });
    }

    setData =(data={}, keepState=false)=> {
        this.data = data;
        this.starttime = data.starttime;
        this.endtime = data.endtime;
        this.processData();


        if(this.refs.slider) {
            this.refs.slider.setData({
                xDomainValue: [
                    data.starttime,
                    data.endtime,
                ],
                data: data.soundTypeData
            })
        }
    };

    isAlarmAllowed =alarm=> {
        return ((this.state.alarmTypes.filter(a=>a.key === alarm.value)[0] || {active:false}).active) &&
            alarm.time >= this.starttime && alarm.time <= this.endtime;
    }

    processData =()=> {
        if(this.map && this.data && this.data.soundTypeData &&  this.data.soundTypeData.length) {
            
            let fitBounds = new window.google.maps.LatLngBounds();
            let position;
            
            for(let idx in this.data.soundTypeData) {
                position = new window.google.maps.LatLng(this.data.soundTypeData[idx].lat, this.data.soundTypeData[idx].long);
                fitBounds.extend(position);
                // new window.google.maps.Marker({
                //     position,
                //     map: this.map
                // });
            }
            this.map.fitBounds(fitBounds);

            /**
             * 
             *  Setting up the grid
             * 
             */

            let latLngUnit = this.state.spotSize / this.kmUnit;
            let gridData = {}; 
            let item;
            let dayMap = {};
            for(let idx=0; idx < this.state.dayFilter.length; idx++) {
                dayMap[idx+1] = this.state.dayFilter[idx].active;
            }

            for(let idx in this.data.soundTypeData) {
                item = this.data.soundTypeData[idx];
                if(!dayMap[moment(item.time).day()])
                    continue;

                let key = (item.lat - (item.lat % latLngUnit)) + '-' + (item.long - (item.long % latLngUnit));
                if(!gridData[key]) {
                    gridData[key] = {
                        lat: (item.lat - (item.lat % latLngUnit)), 
                        lng: (item.long - (item.long % latLngUnit)),
                        latLngUnit,
                        vehicleids: {},
                        data: []
                    }
                    gridData[key].center = {
                        lat: gridData[key].lat + (gridData[key].latLngUnit / 2),
                        lng: gridData[key].lng + (gridData[key].latLngUnit / 2),
                    }
                }
                gridData[key].vehicleids[item.vehicleid] = item.vehicleid;
                if(this.isAlarmAllowed(item)) {
                    gridData[key].data.push(item);
                }
            }

            for(let idx in gridData) {
                gridData[idx].vehicleCount = Object.keys(gridData[idx].vehicleids).length;
            }


            /**
             * 
             *  Drawing
             * 
             */

            for(let idx in this.polygons) {
                this.polygons[idx].setMap(null);
            }
            this.polygons = [];
            let maxAlertCount = 0;
            
            if(this.state.normalizeSpotByVehicle) {
                for(let idx in gridData) {
                    if(gridData[idx].data.length > maxAlertCount) {
                        maxAlertCount = gridData[idx].data.length;
                    }
                }
            } else {
                for(let idx in gridData) {
                    if(gridData[idx].data.length > maxAlertCount) {
                        maxAlertCount = parseInt(gridData[idx].data.length / gridData[idx].vehicleCount);
                    }
                } 
            }

            for(let idx in gridData) {
                if(gridData[idx].data.length >= this.minAlertCount) {
                    let opacity;
                    if(this.state.normalizeSpotByVehicle) {
                        opacity = Math.max(Math.min((gridData[idx].data.length/ gridData[idx].vehicleCount) / maxAlertCount, 1), 0.1) || 0.1;
                    } else {
                        opacity = Math.max(Math.min(gridData[idx].data.length / maxAlertCount, 1), 0.1) || 0.1;
                    }

                    this.polygons.push(new window.google.maps.Circle({
                        // paths: [
                        //     {lat: gridData[idx].lat, lng: gridData[idx].lng},
                        //     {lat: gridData[idx].lat + latLngUnit, lng: gridData[idx].lng},
                        //     {lat: gridData[idx].lat + latLngUnit, lng: gridData[idx].lng + latLngUnit},
                        //     {lat: gridData[idx].lat, lng: gridData[idx].lng + latLngUnit}
                        // ],
                        center: gridData[idx].center,
                        radius: this.getRadius(),
                        strokeColor: '#444',
                        strokeOpacity: opacity,
                        strokeWeight: 1,
                        fillColor: '#FF0000',
                        fillOpacity: opacity,
                        map: this.map
                    }));
                }
            }
            console.log(gridData);
        }
    }
    
    getRadius =()=> {
        if(this.state.scaleSpotSize) {
            let bounds = this.map.getBounds();
            let sizePxRatio = 50 / window.innerWidth;
            return (bounds.getSouthWest().lng() - bounds.getNorthEast().lng()) * this.kmUnit * 1000 / 2 * sizePxRatio;
        }
        return this.state.spotSize * 1000 / 2;
    }

    settingsChanged =(size={value: this.state.spotSize})=> {
        this.setState({spotSize: size.value}, ()=>{
            this.minAlertCount = parseInt(this.refs.minAlertCount.value); 
            this.processData();
        });
    }

    setBusy =(status)=> {
        if(!this.mounted) return;
        this.setState({
            busy: status
        })
    }

    getData =()=> {
        return {}
    }

    zoomChanged =()=> {
        this.reRenderCircle();
    }

    reRenderCircle =()=> {
        for(let idx in this.polygons) {
            this.polygons[idx].setRadius(this.getRadius());
        }
    }

    componentDidMount() {
        this.map = new window.google.maps.Map(this.refs.map, {
            center: window.locations.USR,
            zoom: 11,
            // disableDefaultUI:true,
            clickableIcons: false,
            styles: lightTheme,
            keyboardShortcuts: false
        });
        this.map.addListener('zoom_changed', this.zoomChanged);
    }

    toggleNormalizeSpotByVehicle =()=> {
        this.setState({normalizeSpotByVehicle: !this.state.normalizeSpotByVehicle}, ()=> {
            this.processData();
        })
    }

    toggleScaleSpotSize =()=> {
        this.setState({scaleSpotSize: !this.state.scaleSpotSize}, ()=> {
            this.reRenderCircle();
        })
    }

    toggleAlarm =alarm=> {
       alarm.active =! alarm.active;
       this.setState({alarmTypes: this.state.alarmTypes}, ()=> {
           this.processData();
       })  
    }

    onTimeRangeChange =range=> {
        clearTimeout(this.rectUpdateDebounce);
        this.rectUpdateDebounce = setTimeout(()=>{
            this.starttime = range[0];
            this.endtime = range[1];
            this.processData();
        }, 300);
    }
   
    selectAllVehicles =()=> {
        if(this.props.data.selectAllVehicles) {
            this.props.data.selectAllVehicles();
        }
    }
    
    render(){
        return(
            <div className="InGreySpotter">
                <div className='igs-settings'>
                    <div className='igss-heading'>Grey Spot Settings</div>

                    <div className='igss-days'>
                        <div className='igssd-name'>Grey Spot Size (KmSqr)</div>
                        <div className='igssd-container'>
                            {this.greySpotSize.map((size, index)=> {
                                return (
                                    <div className='igssdc-item' key={index}>
                                        <div className={'igssdci-inner' + (this.state.spotSize === size.value ? ' active' : '')}
                                            onClick={()=>{this.settingsChanged(size)}} >
                                            {size.name}</div>
                                    </div>   
                                )
                            })}
                        </div>
                    </div> 

                    {/* <div className='igss-input'>
                        <div className='igssi-name'>Grey Spot Size (KmSqr)</div>
                        <select onChange={this.settingsChanged} ref='spotSize'>
                            <option value={0.1}>100 meters</option>
                            <option value={0.2}>200 meters</option>
                            <option value={0.5}>500 meters</option>
                            <option value={1}>1 Km</option>
                        </select>
                    </div> */}
                    <div className='igss-input'>
                        <div className='igssi-name'>Min Alert Count</div>
                        <input type='number' min={0} onChange={()=>this.settingsChanged()} 
                            defaultValue={this.minAlertCount} ref='minAlertCount'/>
                    </div> 
                    <div className='igss-days'>
                        <div className='igssd-name'>Days Filter</div>
                        <div className='igssd-container'>
                            {this.state.dayFilter.map((day, index)=> {
                                return (
                                    <div className='igssdc-item' key={index}>
                                        <div className={'igssdci-inner' + (day.active ? ' active' : '')}
                                            onClick={()=>{this.toggleDay(day)}} >
                                            {day.name}</div>
                                    </div>   
                                )
                            })}
                        </div>
                    </div>  
                    <div className='igss-checkbox-set'>
                        <div className='igsscs-checkbox' onClick={this.toggleNormalizeSpotByVehicle}>
                            <div className='igsscsc-icon'>
                                <i className={'fa fa-' + (this.state.normalizeSpotByVehicle ? 'check-square active' : 'square-o')}/>
                            </div>
                            <div className='igsscsc-desc'>Normalize spot by vehicle count</div>
                        </div>
                        <div className='igsscs-checkbox' onClick={this.toggleScaleSpotSize}>
                            <div className='igsscsc-icon'>
                                <i className={'fa fa-' + (this.state.scaleSpotSize ? 'check-square active' : 'square-o')}/>
                            </div>
                            <div className='igsscsc-desc'>Scale spot size on zoom</div>
                        </div>
                    </div>

                    <div className='igss-days'>
                        <div className='igssd-name'>Alarm Filter</div> 
                    </div>  

                    <div className='igss-checkbox-set'>
                        {this.state.alarmTypes.map((alarm, index)=>{
                            return (
                                <div className='igsscs-checkbox' key={index} onClick={()=>this.toggleAlarm(alarm)}>
                                    <div className='igsscsc-icon'>
                                        <i className={'fa fa-' + (alarm.active ? 'check-square active' : 'square-o')}/>
                                    </div>
                                    <div className='igsscsc-desc'>Enable {alarm.name}</div>
                                </div>
                            )
                        })}
                    </div>

                    <div className='igss-button-set'>
                        <div className='igss-button' onClick={this.selectAllVehicles}>Select All Vehicles</div> 
                    </div> 
                </div>
                <div className='gmap-grey-spotter'>
                    <div className='gmgs-map' ref='map'></div>
                </div>
                <div className='gmap-grey-slider'>
                    <InSlider ref='slider' onChange={this.onTimeRangeChange}/>
                </div>
            </div>
        )
    }

}

export default InGreySpotter;